import { IconDefinition } from '@fortawesome/fontawesome-svg-core';

interface SortedColumn {
  column: string;
  asc: boolean;
  icon: IconDefinition;
}

interface TempSortColumn {
  sortedColumn: SortedColumn;
}

interface TableRow {
  [key: string]: any;
  ActivityDate?: string;
}

class SortTableDataUtility {
  private static Instance: SortTableDataUtility | null = null;

  static getInstance(): SortTableDataUtility {
    if (SortTableDataUtility.Instance == null) {
      SortTableDataUtility.Instance = new SortTableDataUtility();
    }

    return SortTableDataUtility.Instance;
  }

  getSortedItems = (tempSortedCol: SortedColumn, tempRows: TableRow[]): TableRow[] => {
    let newRows: TableRow[] = [];

    newRows = tempRows.sort(function (a, b) {
      let x: any, y: any;
      if (tempSortedCol.column === 'ActivityDate') {
        const aValue = a[tempSortedCol.column];
        const bValue = b[tempSortedCol.column];
        x = aValue ? new Date(aValue) : new Date(0);
        y = bValue ? new Date(bValue) : new Date(0);
      } else {
        x = a[tempSortedCol.column] ?? '';
        y = b[tempSortedCol.column] ?? '';
      }

      if (tempSortedCol.asc) return sortAscending(x, y);
      else return sortDescending(x, y);
    });

    //nested functions to retain scope
    function sortAscending(x: any, y: any): number {
      if (x < y) {
        return -1;
      }
      if (x > y) {
        return 1;
      }
      return 0;
    }
    //nested functions to retain scope
    function sortDescending(x: any, y: any): number {
      if (x > y) {
        return -1;
      }
      if (x < y) {
        return 1;
      }
      return 0;
    }

    return newRows;
  };

  toggleSortedColumn = (
    columnToSort: string, 
    tempSortColumn: TempSortColumn, 
    faSortUp: IconDefinition, 
    faSortDown: IconDefinition
  ): void => {
    if (columnToSort === tempSortColumn.sortedColumn.column) {
      tempSortColumn.sortedColumn.asc = !tempSortColumn.sortedColumn.asc;
    } else {
      tempSortColumn.sortedColumn.column = columnToSort;
      tempSortColumn.sortedColumn.asc = false;
    }

    if (tempSortColumn.sortedColumn.asc === true) {
      tempSortColumn.sortedColumn.icon = faSortUp;
    } else {
      tempSortColumn.sortedColumn.icon = faSortDown;
    }
  };
}

export default SortTableDataUtility;
